module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Regular.woff?ae6c6c472cb99f9f79773bc232ac31d7";